export const menuFunctions = {
	dataCellFunctions: {},
	rangeFunctions: {},
	gridFunctions: {}
};




// WEBPACK FOOTER //
// ./src/demo/menuFunctions.js